<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal hide-footer id="create-ep-id" size="lg"
                 title="Create EP ID">
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-content bg-white rounded box-shadow">

                <div class="form-row">
                    <div v-if="this.btn_edit"  class="col-md-6 col-sm-6 col-lg-6">
                        <label class="col-form-label col-form-label-sm" for="ep_id">EP ID</label>
                        <input type="number" v-model="ses_ep.ep_id" v-validate="{ required: true, regex: /^\d*[1-9]\d*$/ }" id="ep_id" name="ep_id" placeholder="EP ID" class="form-control form-control-sm"/>
                        <div class="invalid-feedback">EP ID is required and with numeric number</div>
                    </div>

                    <div v-if="!this.btn_edit"  class="col-md-12 col-sm-12 col-lg-12">
                        <h5>EP ID: <b>{{ this.isPaid}}{{ this.ses_ep.ep_id }}</b></h5>
                        <input type="hidden" v-model="ses_ep.ses_id" id="ses_id" name="ses_id"/>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12">
                      <p><b>Ex:</b> <span v-if="this.isPaid === '1'"> {{ isPaid}}-(Paid), </span><span v-if="this.isPaid === '2'"> {{ isPaid}}-(Not Paid), </span>{{ example_ep.district }}-(District, {{ example_ep.district_name}}), {{ example_ep.upazila }}-(Upazila, {{ example_ep.upazila_name }}), {{ example_ep.union }}-(Union, {{ example_ep.union_name }}), {{ example_ep.form_no }}-(Form no)</p>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <p><input type="checkbox" v-model="boxChecked"> I have check, and found EP ID is right</p>
                </div>
                <div class="form-row mt-2">
                    <label for="sel1">Select payment status</label>
                    <select v-model="isPaid" class="form-control form-control-sm" id="sel1" required>
                        <option value="">Select payment status</option>
                        <option value="1">Paid</option>
                        <option value="2">Not paid</option>
                    </select>
                </div>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <b-button :disabled="!this.boxChecked || this.isPaid == ''" v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">
                            Save
                        </b-button>
                        <b-button :disabled="!boxChecked" v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update</b-button>
                        <b-button class="form-control-sm" size="sm" variant="danger" @click="$bvModal.hide('create-ep-id')">Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        name: "createEpIdModal",
        props: ["ses_ep", "btn_edit", "example_ep", 'isPaid', 'boxChecked'],
        data() {
            return {
                errorMessage: "",
                status: 0,
                message: "",
                validation_errors: {},
                show: false
            };
        },

        mounted() {},
        methods: {
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.ses_ep.is_paid = this.isPaid
                        http
                            .post("api/ses/ep-ids", this.ses_ep)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.boxChecked = false;
                                    this.$bvModal.hide("create-ep-id");
                                    this.$emit("search");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .put("api/ses/ep-ids/" + this.ses_ep.id, this.ses_ep)
                            .then(response => {
                                if(response.data.error === true){
                                    this.validation_errors = response.data.errors;
                                    this.show = true;
                                    this.hide();
                                }else{
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.boxChecked = false;
                                    this.$bvModal.hide("create-ep-id");
                                    this.$emit("search");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    };
</script>
<style>
.button.disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
